// define a mixin object
import DialogOperationRunning from '@/components/DialogOperationRunning'
import DialogError from '@/components/DialogError'
import BreadCrumbs from '@/components/commons/BreadCrumbs'

export default {
  components: {
    DialogOperationRunning,
    DialogError,
    BreadCrumbs
  },
  data() {
    return {
      operationRunningTitle: "INFO"
    };
  },
  created: function() {
    if (!this.$session.get("uuid")) {
      this.$router.push({ path: "/Login/" });
    } else {
      this.$store.dispatch("checkSession");
    }
  },
  methods: {
    hello: function() {
      // console.log('******* hello from mixin! ******')
    },
    loginEffettuato(){
      if (this.$session.get("uuid") == null) return false;
      return true;
    }
  },
  computed: {
    progressMessage: function () {
      // console.log('progressMessage')
      return this.$store.state.progressMessage
    },
    progressMessageEnable: function () {
      // console.log('progressMessageEnable')
      if (this.$store.state.progressMessage == null) {
        return false
      } else {
        return true
      }
    },
    progressLoading: function(){
      return this.$store.state.progressLoading;
    },
    errorMessage: function () {
      return this.$store.state.errorMessage
    },
    errorMessageEnable: function() {
      if (this.$store.state.errorMessage == null) {
        console.log("errorMessageEnable --> false");
        return false;
      } else {
        console.log("errorMessageEnable --> true");
        return true;
      }
    },
    breadcrumbsitems: function () {
      return this.$store.state.breadcrumbsitems
    }
  }
};
